/* eslint-disable jsdoc/require-param-type */
/* eslint-disable jsdoc/require-param-description */
/* eslint-disable jsdoc/check-param-names */
/* eslint-disable jsdoc/valid-types */
/* eslint-disable jsdoc/check-tag-names */
/* eslint-disable jsdoc/require-returns */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, EMPTY } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HIPPO_CONTENT_ENDPOINT } from '../app.constants';
import { ContentDocument } from '../models/content-document.model';
import labelCache from '../../assets/content/labels.json';
import { Timezone } from '../interfaces/timezone.interface';

interface Label {
    key: string;
    value: string;
}

// Assuming labelCache is a cache object with key-value pairs of type string
@Injectable({
    providedIn: 'root'
})

/**
 * The HippoContentService is specifically aimed at fetching content from
 * the Hippo CMS. Because it must assume the specific interface for Hippo
 * content, this service should be revised if the source CMS changes.
 */
export class HippoContentService {

    public hasLabelsFallback: Subject<boolean> = new Subject<boolean>();
    private readonly resourceBundleLabels = '/labels/cpplabels';
    private readonly resourceBundleTimeZones = '/labels/timezones';
    private readonly resourceBundleProducts = '/labels/cppproducts';
    private readonly documentsApi = '/infodocument';

    constructor(private http: HttpClient) {
    }

    /**
     * Returns an observable that fetches content labels from an endpoint,
     * transforming the result to a key: value format in the process.
     * Components do not subscribe directly to this observable.
     * @returns: Observable of Hippo labels and applies fallback from static label cache
     */
    public getLabels$(): Observable<Record<string, string>> {
        return this.http.get<Label[]>(HIPPO_CONTENT_ENDPOINT + this.resourceBundleLabels).pipe(
            map((labels: Label[]) => {
                const labelObject: Record<string, string> = {...labelCache} ;

                labels.forEach((label: Label) => {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    labelObject[label.key] = label.value || labelCache[label.key] || '';
                });

                return labelObject;
            }),
            catchError(() => {
                this.hasLabelsFallback.next(true);
                return EMPTY;
            })
        );
    }

    /**
     * Time zones resource bundle.
     * @returns: Observable of list of possible time zones
     */
    getTimeZones(): Observable<Timezone[]> {
        return this.http.get<Timezone[]>(HIPPO_CONTENT_ENDPOINT + this.resourceBundleTimeZones);
    }

    /**
     * Fetches a content document by UUID from an endpoint. This can be any type of document.
     * @param id: ID in Hippo of the document to be fetched
     * @param id
     * @returns: Observable of the retrieved document
     */
    getContentDocument(id: string): Observable<ContentDocument> {
        return this.http.get<ContentDocument>(HIPPO_CONTENT_ENDPOINT + this.documentsApi + `/${id}`);
    }

    getProductDocument(): Observable<ContentDocument> {
        return this.http.get<ContentDocument>(HIPPO_CONTENT_ENDPOINT + this.resourceBundleProducts);
    }
}
